module.exports = __webpack_public_path__ + "static/img/jojobiztrip.b6ef713.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/jojobiztrip.png
// module id = FLKc
// module chunks = 46